import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/types/content";

interface RelatedArticlesProps {
  articles: Article[];
}

export default function RelatedArticles({ articles }: RelatedArticlesProps) {
  if (articles.length === 0) {
    return null;
  }

  return (
    <section aria-label="相关推荐" className="mt-12 md:mt-16">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-7 h-7 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
            <i className="ri-links-line" aria-hidden="true"></i>
          </span>
          相关推荐
        </h2>
        <span className="text-xs text-foreground-400">顺着看更连贯</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}